<template>
  <ProgressSpinner v-if="!revision"/>
  <Container class="pt-6" v-if="revision">

    <div v-if="revision.regulations?.length === 0">
      <Alert>
        {{
          $t('pages.admin.devices.device_revisions.device_revision.device_revision_view.this_device_revision_may_be_missing_some_required_information')
        }}

        <template #list>
          <li v-if="revision.regulations.length === 0">
            {{ $t('pages.admin.devices.device_revisions.device_revision.device_revision_view.regulations') }}
          </li>
        </template>
      </Alert>
    </div>

    <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
      <PageHeading>{{ revision.name ?? $route.params.revision }}</PageHeading>
    </div>

    <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
      <TabLayout :tabs="tabs" sticky/>
    </div>

    <router-view
        @on-save="onSave"
        @on-delete="$emit('on-delete')"
        @refresh-device-revision="refreshDeviceRevision"
        :revision="revision"
    ></router-view>
  </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import {mapStores} from "pinia";
import Container from "@/Components/Container.vue";
import {useDeviceRevisionsStore} from "@/stores/deviceRevisions.js";
import Alert from "@/Components/Alert.vue";


export default {
  name: "DeviceRevisionView",
  components: {Alert, Container, TabLayout, PageHeading},
  data() {
    return {
      revision: undefined,
    }
  },
  methods: {
    async refreshDeviceRevision() {
      this.revision = await this.deviceRevisionsStore.showDeviceRevision(this.$route.params.revision, {
        fields: {
          device_revisions: 'id,name,device_model_id,key,description'
        },
        include: [
            'regulations',
            'vehicleManufacturers',
        ],
      });
    },
    async onSave() {
      this.$emit('on-save');
    },
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  watch: {
    '$route.params.revision': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.revision === 'NEW') {
            this.revision = {};
          } else {
            await this.refreshDeviceRevision();
          }
        } else {
          this.revision = undefined;
        }
      },
      immediate: true,
    }
  },
  computed: {
    ...mapStores(useDeviceRevisionsStore),
    tabs() {
      return [
        {
          label: this.$t('pages.admin.devices.device_revisions.device_revision.device_revision_view.properties'),
          current: this.$route.name === 'admin.devices.revisions.revision',
          to: {name: 'admin.devices.revisions.revision', params: this.$route.params}
        },
        {
          label: this.$t('pages.admin.devices.device_revisions.device_revision.device_revision_view.regulations_x', { count: this.revision?.regulations?.length }),
          current: this.$route.name === 'admin.devices.revisions.revision.regulations',
          to: {name: 'admin.devices.revisions.revision.regulations', params: this.$route.params},
          permission: 'read:regulations',
          hide: !this.revision.id
        },
        {
          label: this.$t('pages.admin.devices.device_revisions.device_revision.device_revision_view.history'),
          current: this.$route.name === 'admin.devices.revisions.revision.history',
          to: {name: 'admin.devices.revisions.revision.history', params: this.$route.params},
        },
      ].filter(t => (t.permission === undefined || this.$auth.hasPermission(t.permission)) && !t.hide)
    }
  },
}
</script>
